import layoutTypes from '@types/basic/layout'
import userTypes from '@types/basic/user'
import { DEFERRED_SYMBOL } from '@redux/middlewares/deferredActionDispatch'

export const setUsers = payload => ({
  type: layoutTypes.SET_USER,
  payload
})

export const resetUser = () => ({
  type: userTypes.RESET_USER
})

export const setBrandList = payload => ({
  type: userTypes.SET_BRAND_LIST,
  payload
})
export const setStoreChannel = payload => ({
  type: userTypes.SET_STORE_CHANNEL,
  payload
})
export const setAuthCodes = payload => ({
  type: userTypes.UPDATE_AUTH_CODES,
  payload
})

export const fetchBrandList = payload => ({
  type: userTypes.FETCH_BRAND_LIST,
  payload,
  [DEFERRED_SYMBOL]: true
})
export const fetchStoreChannels = payload => ({
  type: userTypes.FETCH_STORE_CHANNEL,
  payload,
  [DEFERRED_SYMBOL]: true
})
export const setRegisterChannel = payload => ({
  type: userTypes.SET_REGISTER_CHANNEL,
  payload
})
export const fetchRegisterChannels = payload => ({
  type: userTypes.FETCH_REGISTER_CHANNEL,
  payload,
  [DEFERRED_SYMBOL]: true
})
export const login = payload => ({
  type: userTypes.LOGIN,
  payload,
  [DEFERRED_SYMBOL]: true
})

export const logout = mode => ({
  type: userTypes.LOGOUT,
  payload: { mode }
})

export const resetUserInfo = payload => ({
  type: userTypes.RESET_USER_INFO,
  payload
})
